import { create } from "zustand";

interface DeviceState {
  isMobile: boolean;
  updateIsMobile: (width: number) => void;
}

// iPhone 16 pro max width = 440px
const MOBILE_BREAKPOINT = 441;

export const useDeviceStore = create<DeviceState>((set) => ({
  isMobile: false,
  updateIsMobile: (width: number) => {
    set({ isMobile: width < MOBILE_BREAKPOINT });
  },
}));
